export default {
  manage_createEditCrew_success: "Tripulación fue creada exitosamente",
  manage_createEditCrew_success_edit: "Tripulación fue actualizada exitosamente",
  manage_createEditCrew_FirstNameInputLabel: "Nombre",
  manage_createEditCrew_LastNameInputLabel: "Apellido",
  manage_createEditCrew_VehicleInputLabel: "Vehículo",
  manage_createEditCrew_VehicleInputLabel: "Vehículo",
  manage_createEditCrew_CreateTitle: "Agregar nuevo Miembro de Tripulación",
  manage_createEditCrew_EditTitle: "Editar Miembro de Tripulación",
  manage_createEditCrew_EditForTitle: "Editar Miembros de Tripulación para",
  manage_createEditCrew_members: "Miembros de Tripulación",
  manage_createEditCrew_ReAssignTitle: "Re-Asignar",
  manage_createEditCrew_AssignTitle: "Asignar",
  manage_createEditCrew_ToTitle: "a",
  manage_createEditCrew_duplicatedCrewErrorMessage: "Este Miembro de Tripulación ya existe"
};
